import type { ComponentProps } from 'preact';
import { useTenantWebsiteBaseHref } from '../../../config/TenantContext';
import { Button } from '../Button/Button';
import { Card } from '../Card/Card';
import { Heading } from '../Heading/Heading';
import { Link } from '../Link/Link';
import styles from './ConsentForm.module.css';

export interface ConsentFormProps {
  onAccept?: ComponentProps<'button'>['onClick'];
  onReject?: ComponentProps<'button'>['onClick'];
}

export function buildPrivacyPolicyHref(tenantWebsiteBaseHref: string | null) {
  if (!tenantWebsiteBaseHref) {
    return '/privacy-policy';
  }

  try {
    return new URL('/privacy-policy', tenantWebsiteBaseHref).toString();
  } catch {
    return '/privacy-policy';
  }
}

export function ConsentForm({ onAccept, onReject }: ConsentFormProps) {
  const tenantWebsiteBaseHref = useTenantWebsiteBaseHref();
  const privacyPolicyHref = buildPrivacyPolicyHref(tenantWebsiteBaseHref);

  return (
    <div className={styles.surface}>
      <Card>
        <div className={styles.content}>
          <Heading as="h3" variant="lg">
            Privacy
          </Heading>
          <p className={styles.description}>
            We use Google Analytics to collect data. This helps us analyse
            performance and optimise our services. By clicking "Accept," you
            agree to our use of these tools for analytical purposes.
          </p>
          <div className={styles.actions}>
            <Button type="button" fullWidth onClick={onAccept}>
              Accept
            </Button>
            <Button
              type="button"
              variant="secondary"
              fullWidth
              onClick={onReject}
            >
              Reject
            </Button>
          </div>
          <div className={styles.privacyPolicyLink}>
            <Link href={privacyPolicyHref} isExternal>
              View our Privacy Policy
            </Link>
          </div>
        </div>
      </Card>
    </div>
  );
}
